export default __webpack_public_path__ + "static/media/hospital-location-pin.c3799813.svg";